import { useQuery } from '@tanstack/react-query';
import { getHrHome } from '../../../api/hrHome';

export const HrHomeQueryKey = 'HR_HOME';

export const useHrHomeQuery = () =>
  useQuery({ queryKey: [HrHomeQueryKey], queryFn: getHrHome });
